/**
 * Day 1 content treatment under Rev 2.1: consultation content is for the
 * customer's internal use and is not included in the OnFrontiers Library.
 *
 * This is the single source of truth for treatment copy. Every surface that
 * states the treatment reads from here so the client and expert wordings
 * cannot drift, and so there is one place to change when the Content Election
 * engine ships and makes the treatment per-account and per-order.
 *
 * Deliberately not sourced from the API: day 1 every account gets the same
 * default, so a column and a GraphQL field would be single-valued with no
 * behavior attached. See ENG-5559.
 */

/** Rendered below the client booking form, above the legal footer. */
export const CLIENT_CONTENT_TREATMENT =
  "recordings, transcripts, and other content from this consultation are for your organization's internal use and will not be included in the OnFrontiers Library, per your account's Content Election.";

/** Heading of the block the expert sees before accepting (EPA 5.18). */
export const EXPERT_CONTENT_TREATMENT_HEADING = 'Content treatment for this consultation';

/**
 * Body of that block. The attribution sentence states the EPA 5.14 no-election
 * fallback: absent an election, the expert is listed by professional title.
 */
export const EXPERT_CONTENT_TREATMENT =
  'The client receives recordings, transcripts, and related content for their internal use only. This content will not be included in the OnFrontiers Library. If it is ever included in the Library later, you will be listed by your professional title unless you have chosen to be named.';

/**
 * Third-party AI-training transfer line.
 *
 * Intentionally empty. The spec left this sentence unwritten (2B) because no
 * order carries that treatment yet, so no approved wording exists. The slot and
 * its flag are wired so that adding the sentence later is a copy change rather
 * than a structural one, and so that nothing renders in the meantime even if
 * the flag is turned on by accident.
 *
 * Do not fill this in without Legal and product sign-off. It is a disclosure
 * about transferring an expert's consultation content to a third party.
 */
export const EXPERT_TRANSFER_TREATMENT = '';

/**
 * GrowthBook key gating EXPERT_TRANSFER_TREATMENT. Defaults off.
 *
 * This is a launch switch, not a per-order discriminator. It knows nothing
 * about which client or which order elected the treatment, so it must not be
 * enabled until the Content Election engine supplies that signal. Turning it on
 * beforehand would state the treatment to every expert on every consultation.
 */
export const EXPERT_TRANSFER_TREATMENT_FLAG = 'expert-content-treatment-transfer-line';
